(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["zoh-product-share"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__zohProductShareBound) return;
    window.__zohProductShareBound = true;

    document.addEventListener('click', async (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const button = target.closest('[data-zoh-product-share-copy]');
      if (!(button instanceof HTMLElement)) return;

      const root = button.closest('[data-zoh-product-share]');
      if (!(root instanceof HTMLElement)) return;

      const shareUrl = root.getAttribute('data-share-url');
      if (!shareUrl) return;

      event.preventDefault();

      try {
        await navigator.clipboard.writeText(shareUrl);
      } catch {
        const textarea = document.createElement('textarea');
        textarea.value = shareUrl;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        textarea.remove();
      }

      const status = root.querySelector('[data-zoh-product-share-status]');
      const message =
        (window.Theme && window.Theme.translations && window.Theme.translations.wishlist_share_copied) ||
        'Link copied';

      if (status instanceof HTMLElement) {
        status.textContent = message;
        status.classList.remove('visually-hidden');
        window.setTimeout(() => {
          status.textContent = '';
          status.classList.add('visually-hidden');
        }, 2000);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
